import React, { FC, useState } from "react";
import { Button, Icon, Modal } from "semantic-ui-react";

type Props = {
  onClick: () => void;
  label: string;
  modal: {
    title: string;
    description: string;
  }
}

const DeleteButton: FC<Props> = ({onClick, label, modal}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Modal
        onClose={ () => setOpen(false) }
        onOpen={ () => setOpen(true) }
        open={ open }
        trigger={
          <Button
            icon
            negative
            labelPosition="left"
          >
            <Icon name="trash"/>
            { label }
          </Button>
        }
      >
        <Modal.Header>
          { modal.title }
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            { modal.description }
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
          <Button
            icon
            negative
            labelPosition="left"
            onClick={ () => {
              setOpen(false);
              onClick();
            } }
          >
            <Icon name="trash"/>
            { label }
          </Button>
        </Modal.Actions>
      </Modal>

    </>
  );
}

export default DeleteButton;